import React from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Menu from "@src/sharedComponents/Menu/Menu";
import { MenuOption } from "@src/sharedComponents/Menu/MenuOption";

type Props = {
  markAllSecurities: () => void;
  unmarkAllSecurities: () => void;
};

const DoNotSellActionMenu: React.FC<Props> = ({
  markAllSecurities,
  unmarkAllSecurities,
}) => {
  const menuItems: MenuOption[] = [
    {
      label: "Mark all securities",
      onClick: markAllSecurities,
      isCloseOnClick: true,
      isDisabled: false,
    },
    {
      label: "Unmark all securities",
      onClick: unmarkAllSecurities,
      isCloseOnClick: true,
      isDisabled: false,
    },
  ];

  return (
    <Menu
      anchorOrigin={{ horizontal: "left", vertical: "top" }}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      options={menuItems}
    >
      {({ handleOpenMenu }) => (
        <IconButton onClick={handleOpenMenu} IconComponent={MoreHorizIcon} />
      )}
    </Menu>
  );
};

export default DoNotSellActionMenu;
